import { matchPath, useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { ANY_SPORT_SERIES } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import {
  SPORT_PATH_MAP,
  matchAnySportPath,
} from '#src/lib/routing/generateSportPath.ts';

import { useIsSharedProSetPath } from './useIsSharedProSetPath.ts';

export const useSeriesNav = () => {
  const { currentUser } = useCurrentUserContext();
  const { pathname } = useLocation();
  const isSharedProSetPath = useIsSharedProSetPath();

  if (isSharedProSetPath(pathname)) {
    return !currentUser?.anyUserSportProfile?.proUnlocked;
  }

  const isSeriesPage = !!matchAnySportPath(
    catchAll(ANY_SPORT_SERIES),
    pathname
  );
  if (isSeriesPage) {
    return true;
  }

  const isSportPage = Object.values(SPORT_PATH_MAP).some(path =>
    matchPath(catchAll(path), pathname)
  );
  if (isSportPage) {
    return false;
  }

  return !currentUser?.anyUserSportProfile?.proUnlocked;
};
